import { Component, Input } from '@angular/core';

import { IArticle, IQuotes, ISection } from '@amfam/shared/models';

@Component({
  selector: 'amfam-review-quote',
  templateUrl: './review-quote.component.html',
  styleUrls: ['./review-quote.component.scss'],
  standalone: false
})
export class ReviewQuoteComponent {
  @Input() quotes: IQuotes;
  @Input() vehicleAdded: IArticle;
  @Input() vehicleRemoved: IArticle;
  @Input() vehiclesLeft: IArticle;
  @Input() vehicleCoverages: ISection;
  @Input() policyCoverages: ISection;
  @Input() discounts: ISection;
  @Input() futurePayments: ISection;
  @Input() disclaimer: string;
}
